const _ = /* @__PURE__ */ Symbol("rootPickerContextKey"), o = "ElIsDefaultFormat";
export {
  _ as ROOT_PICKER_INJECTION_KEY,
  o as ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY
};
